import React from 'react';
import { light_theme_tokens } from '@/styles/themes/tokens';

interface PlayIconProps {
	size?: number;
	backgroundColor?: string;
	playColor?: string;
	opacity?: number;
}

export const PlayIcon = ({
	size = 52,
	backgroundColor = 'white',
	playColor = light_theme_tokens.primary_colors[500],
	opacity = 0.5
}: PlayIconProps): JSX.Element => {
	return (
		<svg width={size} height={size} viewBox="0 0 52 52" fill="none" xmlns="http://www.w3.org/2000/svg">
			<rect width="52" height="52" rx="24" fill={backgroundColor} fillOpacity={opacity} />
			<path
				d="M15 39.3985V12.7867C15 9.63033 18.4846 7.71747 21.1475 9.41205L42.5667 23.0425C45.0688 24.6347 45.0288 28.3008 42.4924 29.8379L21.0732 42.8193C18.4074 44.4349 15 42.5156 15 39.3985Z"
				fill={playColor}
			/>
		</svg>
	);
};
